export default __webpack_public_path__ + "static/media/gallery-wip-emitter_09.43f2f62a.jpg";